import { useStyles } from '@webapps/styles';
import { useHistory } from 'react-router-dom';
import { useAuth, useQuery, useLocalStorage, useRouter } from '@webapps/reactjs-tech-components';
import { getInviteExternal } from '@webapps/business';
import { ROUTES_PATH } from 'config/constants';
import { useEffect } from 'react';

import theme from './theme';

const {
  colors: { textNotFoundColor },
} = theme;

const InviteExternal = () => {
  const { classes } = useStyles(styles);
  const { push } = useHistory();
  const { params } = useRouter();
  const { profile } = useAuth();

  const [x, setInvite] = useLocalStorage('invite');

  const { id } = params;

  const {
    data: invite = {}
  } = useQuery(getInviteExternal, {
    key: ['invite', id],
    variables: { id, from: 'invite' },
  });

  useEffect(() => {
    if (invite?.id) {
      if(!profile) {
        setInvite({id: invite.id, email: invite.email, type: invite.type})
        push(ROUTES_PATH.SIGN_UP2);
      } else if (profile === "BUSINESS") {
        setInvite({id: invite.id, type: invite.type})
        push(ROUTES_PATH.BUSINESS_DASHBOARD);
      }
    }
  }, [invite]);

  return (
    <div className={classes.container}>
     
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  paper: {
    width: '50%',
    height: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  textNotFound: {
    fontWeight: 600,
    fontSize: fontSizes(25),
    color: textNotFoundColor,
  },
  btnBack: {
    marginTop: spacing(3),
  },
});

export default InviteExternal;
